import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Representante } from '../../../models/representante.model';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng9-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-representante",
    templateUrl: "./representante.component.html",
    providers: [UserService, FormService]
})

export class RepresentanteComponent {

    @ViewChild('openModal', { static: true }) openModal: TemplateRef<any>;
    public rut_rep;
    public mail_rep;
    public invalidRut: Boolean;
    public representante: Representante;
    public rows = [];
    public actualRow;
    public matcher = new FormService();

    public filteredOptions;
    public nombreComuna = new FormControl('', [Validators.required]);
    options = []
    public selectedRep: number = null;

    constructor(private fb: FormBuilder, private _userService: UserService,
        rutValidator: RutValidator, public dialog: MatDialog, private spinner: NgxSpinnerService) {
        this.rut_rep = this.fb.group({
            rut: ['', [Validators.required, rutValidator]]
        })
        this.mail_rep = this.fb.group({
            mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
        })

        if (!JSON.parse(localStorage.getItem("representantes"))) {
            localStorage.setItem("representantes", JSON.stringify(this.rows));
        } else {
            this.rows = JSON.parse(localStorage.getItem("representantes"));
            //console.log(this.rows)
        }
        this.invalidRut = true;
        this.representante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
    }
    regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    ngOnInit() {
        this.getComunas()
        this.filteredOptions = this.nombreComuna.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();

        return this.options.filter(option => option.toLowerCase().includes(filterValue));
    }


    get_representante(rut) {
        window.scroll(0, 0);
        this.spinner.show();
        this.cleanData();
        this._userService.getRepresentante(rut).subscribe(
            response => {
                if (response.message) {
                    this.representante.rut = rut ? rut : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal)
                } else {
                    this.representante.rut = response.rut ? response.rut : '';
                    this.representante.nombre = response.nombre ? response.nombre : '';
                    this.representante.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
                    this.representante.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
                    this.representante.direccion = response.direccion ? response.direccion : '';
                    this.representante.direccion_num = response.direccion_num ? response.direccion_num : '';
                    this.representante.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
                    this.representante.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
                    this.representante.comuna = response.comuna ? response.comuna : '';
                    this.representante.fono = response.fono ? response.fono : '';
                    this.representante.mail = response.mail ? response.mail : '';
                    this.representante.recordId = response.recordId ? response.recordId : '';
                    this.spinner.hide();
                    this.dialog.open(this.openModal)
                }

            },
            error => {
                console.log(error)
                this.spinner.hide();
            }
        )
    }

    cleanData() {
        this.representante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
        this.rut_rep.reset()
    }

    update_representante(rut, id) {
        this.get_representante(rut);
        this.selectedRep = id;
    }

    saveRepresentante() {
        window.scroll(0, 0);
        //por si escriben un rut que ya esté ingresado
        for (let x = 0; x < this.rows.length; x++) {
            if (this.representante.rut == this.rows[x].rut) {
                this.delete_representante(x);
            }
        }

        //elimina fila cuando la editan
        /*if (this.selectedRep != null) {
            this.delete_representante(this.selectedRep);
            this.selectedRep = null;
        }*/

        this.spinner.show();
        this._userService.saveRepresentante(this.representante).subscribe(
            response => {
                this.spinner.hide();

                console.log(response)
                if (response.update || response.save) {
                    $("#rep_modal").modal("hide");
                    this.actualRow = localStorage.getItem("representantes");
                    this.rows = JSON.parse(this.actualRow);
                    this.rows = this.rows.concat({
                        rut: this.representante.rut,
                        nombre: this.representante.nombre,
                        apellido_pat: this.representante.apellido_pat,
                        apellido_mat: this.representante.apellido_mat,
                        direccion: this.representante.direccion,
                        direccion_num: this.representante.direccion_num,
                        direccion_complemento: this.representante.direccion_complemento,
                        direccion_completa: this.representante.direccion_completa,
                        comuna: this.representante.comuna,
                        fono: this.representante.fono,
                        mail: this.representante.mail
                    })
                    localStorage.setItem("representantes", JSON.stringify(this.rows));
                    this.representante = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', mail: '', recordId: '' };
                    this.rut_rep.reset()
                    this.dialog.closeAll();

                }
            },
            error => {
                this.spinner.hide();

                console.log(error)
            }
        )
    }
    delete_representante(id) {
        for (let x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("representantes", JSON.stringify(this.rows));
                this.rows = JSON.parse(localStorage.getItem('representantes'));
            }
        }
    }

    getComunas() {

        this._userService.getComunas().subscribe(res => {
            //console.log('res', res);
            for (let i = 0; i < res.length; i++) {
                this.options.push(res[i].fieldData.COM_Nombre)
            }

            this.filteredOptions = this.nombreComuna.valueChanges
                .pipe(
                    startWith(''),
                    map(value => this._filter(value))
                );
        }, error => {
            console.log(error)
        })
    }
}